import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { ComboboxPortalProps } from "./Combobox.types";

export function ComboboxPortal({
  children,
  ...props
}: ComboboxPortalProps): JSX.Element {
  const container = useFloatingPortalContainer();

  return (
    <BaseCombobox.Portal container={container} {...props}>
      {children}
    </BaseCombobox.Portal>
  );
}
